/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { AssetType, IMediaModel, TimeHelper } from "@bms/common";

import "./MatchStartInfo.scss";

type IMatchStartInfoProps = {
  media: IMediaModel;
};

export const MatchStartInfo = (props: IMatchStartInfoProps) => {
  const { media } = props;

  if (media.MediaTypeCode !== AssetType.Match || !media.StartDateTime) {
    return null;
  }

  return (
    <div className="MatchStartInfo">
      {TimeHelper.format(media.StartDateTime, "DD.MM.YYYY HH:mm")}
    </div>
  );
};
